export enum QueryKeys {
  profile = 'profile',
  employers = 'employers',
  employer = 'employer',
  controlPerson = 'controlPerson',
  iraUsers = 'iraUsers',
  iraUser = 'iraUser',
  documents = 'documents',
  userBlocked = 'userBlocked',
  independentIraUsers = 'independentIraUsers',
  independentIraUsersMetrics = 'independentIraUsersMetrics',
  independentIraUser = 'independentIraUser',
  profileList = 'profileList',
  contributionsList = 'contributionsList',
  contributionDetails = 'contributionDetails',
  allAssets = 'allAssets',
  profileAssets = 'profileAssets',
  profileTransactions = 'profileTransactions',
  profileBalance = 'profileBalance',
  etzProfileBalance = 'etzProfileBalance',
  etzProfileAssets = 'etzProfileAssets',
  etzProfileTransactions = 'etzProfileTransactions',
  etzProfileRevenueByMonth = 'etzProfileRevenueByMonth',
  etzProfileInflowOutflowByMonth = 'etzProfileInflowOutflowByMonth',
  defaultUserManagers = 'defaultUserManagers',
  usersToAssignWalletTransfer = 'usersToAssignWalletTransfer',
  activeLimitOrders = 'activeLimitOrders',
  openOrders = 'openOrders',
}
